/* Keep the existing gallery autoplay; fetch its media only near the viewport. */
(() => {
  if (window.aonaGalleryVideos) {
    window.aonaGalleryVideos.init(document);
    return;
  }

  const selector = 'video[data-aona-lazy-video]';
  const observed = new WeakSet();
  const load = (video) => {
    const sources = [...video.querySelectorAll('source[data-aona-video-src]')];
    if (!sources.length) return;
    sources.forEach((source) => {
      source.src = source.dataset.aonaVideoSrc;
      source.removeAttribute('data-aona-video-src');
    });
    video.muted = true;
    video.load();
    if (video.autoplay) {
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    }
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          load(entry.target);
        });
      }, { rootMargin: '400px 0px', threshold: 0 })
    : null;

  const init = (root) => {
    root.querySelectorAll(selector).forEach((video) => {
      if (observed.has(video)) return;
      observed.add(video);
      if (observer) observer.observe(video);
      else load(video);
    });
  };
  window.aonaGalleryVideos = { init };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (observer) event.target.querySelectorAll(selector).forEach((video) => observer.unobserve(video));
  });
})();
